<template>
  <nav :aria-label="$t('ux.molecules.mainNav.aria')" :class="['Main-nav', { 'Main-nav--homepage': isHomepage }]" role="navigation">
    <div class="Grid-layout Main-nav__grid">
      <div class="Main-nav__container">
        <ux-atoms-button @click="toggleMenu" class="Main-nav__button Main-nav__burger" no-border ref="dropdownButton" variant="action">
          <span class="Main-nav__burger-icons">
            <ux-atoms-icon :class="['Main-nav__burger-icon', { 'Main-nav__burger-icon--hidden': dropdownIsOpen }]" name="burger" size="l" />
            <ux-atoms-icon :class="['Main-nav__burger-icon', { 'Main-nav__burger-icon--hidden': !dropdownIsOpen }]" name="close-menu" size="l" />
            <span class="accessibility-sr-only">
              {{ srOnlyMenuText }}
            </span>
          </span>
        </ux-atoms-button>
        <ux-atoms-logo class="Main-nav__logo" />
        <ux-molecules-main-nav-menu :dropdown-is-open="dropdownIsOpen" @dropdown::close="toggleMenu" ref="dropdownMainNav" />
        <ux-molecules-nav-account />
      </div>
    </div>
  </nav>
</template>
<script setup lang="ts">
import { getPageName } from '~/helpers/getPageName';

const route = useRoute();
const dropdownIsOpen = ref<boolean>(false);
const SCROLL_DISABLED = 'overflow-hidden';
const { t } = useI18n();
const dropdownMainNav = ref<HTMLElement>();
const dropdownButton = ref<{ root: HTMLButtonElement } & HTMLElement>();

const toggleMenu = () => {
  dropdownIsOpen.value = !dropdownIsOpen.value;
};

const closeMenu = () => {
  dropdownIsOpen.value = false;
};

onClickOutside(dropdownMainNav, (e) => {
  if (e.target !== dropdownButton?.value && !dropdownButton?.value?.root?.contains(e.target as HTMLElement)) {
    closeMenu();
  }
});

const isHomepage = computed(() => {
  return getPageName(route.name)?.startsWith('country___');
});

const srOnlyMenuText = computed(() => {
  return dropdownIsOpen.value ? t('ux.molecules.mainNav.menu.closeMenu') : t('ux.molecules.mainNav.menu.openMenu');
});

watch(
  () => dropdownIsOpen.value,
  (value) => {
    if (value) {
      nextTick(() => {
        document.body.classList.add(SCROLL_DISABLED);
      });
    } else {
      document.body.classList.remove(SCROLL_DISABLED);
    }
  }
);

onMounted(() => {
  document.body.classList.remove(SCROLL_DISABLED);
});
</script>
<style lang="scss" scoped>
@use 'MainNav.scss';
</style>
